module.exports = __webpack_public_path__ + "static/Menu_Tudor-67c3a2577a56b8fca1af774b245d66fe.pdf";